import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
  bookBalance: 0,
};

export const getEntryBookList = createAsyncThunk(
  "get-entry-book",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("entry-book/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createEntryBook = createAsyncThunk(
  "create-entry-book",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("entry-book", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const entrybookSlice = createSlice({
  name: "entryBook",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEntryBookList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEntryBookList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.entryBookList;
        state.perPage = action?.payload?.data?.data?.perPage;
        state.total = action?.payload?.data?.data?.total;
        state.bookBalance = action?.payload?.data?.data?.bookBalance;
      })
      .addCase(getEntryBookList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default entrybookSlice.reducer;
